import {GET_TokenUserRegister} from '../constants/ActionTypes'

const INIT_STATE = {
    
    userToken: null,

    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_TokenUserRegister:
            return {
                userToken: action.body,
                loading :false
                
            }
           
        default:
            return state;
    }
}